import { LAYOUT_TEMPLATES } from './layouteditor/utils/layoutTemplates';

export default function LayoutWizard({ formData, venues, onInputChange, onNext }) {
  const typeOptions = [
    {
      value: 'SEAT_PLAN',
      label: 'Koltuk Planı',
      description: 'Belirli pozisyonlarda bireysel koltuk atamaları',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
      ),
    },
    {
      value: 'AREA_LAYOUT',
      label: 'Alan Düzeni',
      description: 'Blok / tribün seçimli alan planı (koltuk yerine alan)',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
          />
        </svg>
      ),
    },
    {
      value: 'MIXED',
      label: 'Karışık',
      description: 'Atanmış koltuklar ve genel alanların kombinasyonu',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
      ),
    },
  ];

  const showTemplates =
    formData.type === 'AREA_LAYOUT' ||
    formData.type === 'MIXED' ||
    (formData.type === 'SEAT_PLAN' && formData.useZones === true);

  const areaTemplates = LAYOUT_TEMPLATES.filter(
    (t) => t.id === 'blank' || t.category === 'area' || t.category === 'all',
  );

  const setType = (value) => {
    onInputChange({ target: { name: 'type', value } });
    if (value === 'AREA_LAYOUT' || value === 'MIXED') {
      onInputChange({ target: { name: 'useZones', value: true } });
      if (!formData.templateId) {
        onInputChange({ target: { name: 'templateId', value: 'amphitheater' } });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.venueId || !formData.type) {
      return;
    }

    if (formData.type === 'SEAT_PLAN' && formData.useZones === undefined) {
      return;
    }

    if ((formData.type === 'AREA_LAYOUT' || formData.type === 'MIXED') && !formData.templateId) {
      onInputChange({ target: { name: 'templateId', value: 'amphitheater' } });
    }

    onNext();
  };

  const TemplatePreview = ({ preview }) => {
    if (preview === 'amphitheater') {
      return (
        <svg viewBox="0 0 120 80" className="w-full h-16">
          <rect x="35" y="62" width="50" height="12" rx="2" fill="#6B7280" />
          <path
            d="M10 58 A50 42 0 0 1 110 58 L95 48 A35 30 0 0 0 25 48 Z"
            fill="#0D9488"
            opacity="0.85"
          />
          <path
            d="M22 50 A40 34 0 0 1 98 50 L88 42 A28 24 0 0 0 32 42 Z"
            fill="#F87171"
            opacity="0.9"
          />
          <path
            d="M34 42 A26 22 0 0 1 86 42 L78 36 A16 14 0 0 0 42 36 Z"
            fill="#0D9488"
            opacity="0.9"
          />
          <path d="M52 38 A10 8 0 0 1 68 38 L64 33 A5 4 0 0 0 56 33 Z" fill="#BE185D" />
        </svg>
      );
    }
    if (preview === 'rect') {
      return (
        <svg viewBox="0 0 120 80" className="w-full h-16">
          {[0, 1, 2].map((r) =>
            [0, 1, 2, 3].map((c) => (
              <rect
                key={`${r}-${c}`}
                x={8 + c * 28}
                y={6 + r * 18}
                width={24}
                height={14}
                rx="2"
                fill={(r + c) % 2 === 0 ? '#0D9488' : '#F87171'}
              />
            )),
          )}
          <rect x="8" y="62" width="104" height="12" rx="2" fill="#6B7280" />
        </svg>
      );
    }
    if (preview === 'u') {
      return (
        <svg viewBox="0 0 120 80" className="w-full h-16">
          <rect x="8" y="8" width="104" height="14" fill="#0D9488" />
          <rect x="8" y="8" width="16" height="64" fill="#F87171" />
          <rect x="96" y="8" width="16" height="64" fill="#F87171" />
          <rect x="30" y="30" width="60" height="30" fill="#6B7280" />
        </svg>
      );
    }
    return (
      <div className="h-16 flex items-center justify-center text-[11px] text-gray-400 border border-dashed border-gray-300 rounded">
        Boş
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Layout Bilgilerini Girin</h2>
        <p className="text-gray-600">Venue seçimi, tip ve hazır şablon</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-3">
            Layout Adı *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={onInputChange}
            required
            className="text-black w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
            placeholder="Örnek: Ana Konser Salonu Layout"
          />
        </div>

        <div>
          <label htmlFor="venueId" className="block text-sm font-medium text-gray-700 mb-3">
            Venue Seçimi *
          </label>
          <select
            id="venueId"
            name="venueId"
            value={formData.venueId}
            onChange={onInputChange}
            required
            className="text-black w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
          >
            <option value="">Venue seçin...</option>
            {venues.map((venue) => (
              <option key={venue.id} value={venue.id}>
                {venue.name} {venue.city && `- ${venue.city}`}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-4">Layout Tipi *</label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {typeOptions.map((option) => (
              <div
                key={option.value}
                className={`relative cursor-pointer rounded-xl border-2 p-6 transition-all ${
                  formData.type === option.value
                    ? 'border-[#AE256D] bg-pink-50 ring-2 ring-pink-200'
                    : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                }`}
                onClick={() => setType(option.value)}
              >
                <div className="flex flex-col items-center text-center space-y-3">
                  <div
                    className={formData.type === option.value ? 'text-[#AE256D]' : 'text-gray-400'}
                  >
                    {option.icon}
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{option.label}</div>
                    <div className="text-xs text-gray-500 mt-1">{option.description}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {formData.type === 'SEAT_PLAN' && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Zone Yapılandırması</h3>
            <div className="space-y-3">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="useZones"
                  checked={formData.useZones === true}
                  onChange={() => onInputChange({ target: { name: 'useZones', value: true } })}
                  className="h-4 w-4 text-[#AE256D] focus:ring-[#AE256D] border-gray-300"
                />
                <span className="ml-3">
                  <span className="block text-sm font-medium text-gray-700">
                    Zone&apos;larla Organize Et
                  </span>
                  <span className="block text-sm text-gray-500">
                    VIP, Premium, Genel — şablon da seçebilirsin
                  </span>
                </span>
              </label>

              <label className="flex items-center">
                <input
                  type="radio"
                  name="useZones"
                  checked={formData.useZones === false}
                  onChange={() => {
                    onInputChange({ target: { name: 'useZones', value: false } });
                    onInputChange({ target: { name: 'templateId', value: 'blank' } });
                  }}
                  className="h-4 w-4 text-[#AE256D] focus:ring-[#AE256D] border-gray-300"
                />
                <span className="ml-3">
                  <span className="block text-sm font-medium text-gray-700">Tek Düzen Layout</span>
                  <span className="block text-sm text-gray-500">Tüm koltuklar aynı kategoride</span>
                </span>
              </label>
            </div>
          </div>
        )}

        {showTemplates && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Hazır şablon *</label>
            <p className="text-sm text-gray-500 mb-4">
              Görseldeki gibi amfi / arena blok planı seçebilir veya boş başlayıp kendin
              çizebilirsin. Şablon editörde de değiştirilebilir.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {areaTemplates.map((tpl) => {
                const selected = (formData.templateId || 'blank') === tpl.id;
                return (
                  <button
                    key={tpl.id}
                    type="button"
                    onClick={() => onInputChange({ target: { name: 'templateId', value: tpl.id } })}
                    className={`text-left rounded-xl border-2 p-3 transition-all ${
                      selected
                        ? 'border-[#AE256D] bg-pink-50 ring-2 ring-pink-200'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <TemplatePreview preview={tpl.preview} />
                    <div className="mt-2 font-semibold text-sm text-gray-900">{tpl.name}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5 leading-snug">
                      {tpl.description}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-3">
            Açıklama (Opsiyonel)
          </label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={onInputChange}
            rows={3}
            className="text-black w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Layout hakkında ek bilgiler..."
          />
        </div>

        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <input
              type="checkbox"
              id="isActive"
              name="isActive"
              checked={formData.isActive}
              onChange={onInputChange}
              className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <div>
              <label htmlFor="isActive" className="block text-sm font-medium text-gray-900">
                Layout&apos;u aktif olarak oluştur
              </label>
            </div>
          </div>
        </div>

        <div className="flex justify-end pt-6 border-t border-gray-200">
          <button
            type="submit"
            disabled={
              !formData.name ||
              !formData.venueId ||
              !formData.type ||
              (formData.type === 'SEAT_PLAN' && formData.useZones === undefined)
            }
            className="px-8 py-3 bg-[#AE256D] text-white rounded-lg hover:bg-[#B6397A] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
          >
            <span>Devam Et</span>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </form>

      <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="text-sm font-medium text-blue-900 mb-1">İpuçları</h3>
        <ul className="text-sm text-blue-800 space-y-1">
          <li>
            • <strong>Alan Düzeni:</strong> Blok seçimli plan (A1, B3, VIP…) — koltuk yerine alan
          </li>
          <li>
            • <strong>Amfitiyatro şablonu:</strong> Görseldeki gibi radyal A/B/C halkaları + sahne
          </li>
          <li>
            • <strong>Koltuk Planı:</strong> Zone içine tek tek koltuk boyama
          </li>
        </ul>
      </div>
    </div>
  );
}
